
















import Vue from 'vue'
import {SelectValue} from '../ActiveForm/BZCore/Fields/SelectField'

export default Vue.extend({
  name: 'UiSelectInput',
  props: {
    value: {},
    required: {
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    selectList: {
      type: Array as () => SelectValue[],
      default: () => []
    }
  },
  methods: {
    onInput (event: string | number) {
      this.$emit('input', event)
    }
  },
  computed: {
    currentValue: {
      get (): any {
        if (this.multiSelect && !this.value) {
          return [];
        }
        return this.value
      },
      set () {
      }
    }
  }
})
